import type {BaseExperiments, BaseFlags} from 'src/types';

export const defaultExperiment = 'control';
export const defaultFlag = false;

export const baseExperiments: BaseExperiments = {
  control: 'control',
};

export const baseFlags: BaseFlags = {
  true: true,
  false: false,
};
